import {Injectable} from '@angular/core';
import {environment} from "../../../environments/local/environment";
import {app, authentication} from "@microsoft/teams-js";
import {Router} from "@angular/router";
import {IJWTToken, UserInfo} from "../../model/token";
import {LoggingService} from "../error-handling/logging.service";

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  redirectUrl?: string;
  private _securedHosts: string[] = [environment.backend.endpoint.host];
  context?: app.Context;

  constructor(private router: Router, private loggingService: LoggingService) {
  }

  public get securedHosts(): string[] {
    return this._securedHosts;
  }

  getClientSideToken(): Promise<string> {
    return new Promise((resolve, reject) => {
      this.loggingService.logDebug("Get auth token from Microsoft Teams");
      authentication.getAuthToken().then((result) => {
        console.log(result);
        resolve(result);
      }).catch((error) => {
        console.error(error);
        reject("Error getting token: " + error);
      });
    });
  }

  onAuthenticationFailed() {//on getTokenFailed or initialisation failed
    this.router.navigate(['auth-failed'])
  }

  async getMyUserInfo(): Promise<UserInfo> {
    const token = await this.getClientSideToken();
    let userInfo = new UserInfo();

    try {

      if (token) {
        const tokenL1Decoded: IJWTToken = this.decodeJWTToken(token);
        userInfo.display_name = `${tokenL1Decoded.payload.given_name} ${tokenL1Decoded.payload.family_name}`;
        userInfo.userId = tokenL1Decoded.payload.sub;
        userInfo.email = tokenL1Decoded.payload.email;
      }
    } catch (e) {
      // No handling required.
    }

    return userInfo;
  }

  private decodeJWTToken(token: string): IJWTToken {
    const parts = token.split('.');
    let header;
    let payload;

    if (parts.length !== 3) {
      throw Error('Cannot decode a malformed JWT');
    }

    try {
      header = JSON.parse(this.urlBase64Decode(parts[0]));
      payload = JSON.parse(this.urlBase64Decode(parts[1]));
    } catch (e) {
      // @ts-ignore
      throw Error(e);
    }

    return {
      header,
      payload,
      encoded: {
        header: parts[0],
        payload: parts[1],
        signature: parts[2]
      }
    };
  }

  //TODO =====> Find another solution for the decoding! "atob" is buggy and this is just a fix from nebular (recommended to go away from it)
  /**
   * Helper function for UTF-8 decoding of a b64 encoded string.
   * @param str
   */
  private b64DecodeUnicode(str: string): string {
    // Going backwards: from bytestream, to percent-encoding, to original string.
    return decodeURIComponent(Array.prototype.map.call(this.b64decode(str), function (c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
  }

  private urlBase64Decode(str: string): string {
    let output = str.replace(/-/g, '+').replace(/_/g, '/');
    switch (output.length % 4) {
      case 0: {
        break;
      }
      case 2: {
        output += '==';
        break;
      }
      case 3: {
        output += '=';
        break;
      }
      default: {
        throw new Error('Illegal base64url string!');
      }
    }
    return this.b64DecodeUnicode(output);
  }

  private b64decode(str: string) {
    let chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
    let output = '';

    str = String(str).replace(/=+$/, '');

    if (str.length % 4 === 1) {
      console.error("'atob' failed: The string to be decoded is not correctly encoded.");
    }

    for (
      // initialize result and counters
      var bc = 0, bs, buffer, idx = 0;
      // get next character
      buffer = str.charAt(idx++);
      // character found in table? initialize bit storage and add its ascii value;
      ~buffer && (bs = bc % 4 ? bs! * 64 + buffer : buffer,
        // and if not first of each 4 characters,
        // convert the first 8 bits to one ascii character
      bc++ % 4) ? output += String.fromCharCode(255 & bs >> (-2 * bc & 6)) : 0
    ) {
      // try to find character in table (0-63, not found => -1)
      buffer = chars.indexOf(buffer);
    }
    return output;
  }
}
